<template>
  <div class="choose-warehouse clearfix">
    <div class="area-content">
      <compWrapper
        v-for="item in areaData"
        theme="primary"
        :key="item.name"
        :title="item.name"
      >
        <div style="padding: 15px">
          <RadioGroup
            style="width: 100%; display: flex; justify-content: left"
            v-model="areaId"
            @on-change="handleAreaChange"
          >
            <Radio
              style="width: 180px"
              v-for="item in item.items"
              :key="item.id"
              :label="item.id"
              >{{ item.areaName
              }}{{
                item.regionCode ? "（" + item.regionCode + "）" : ""
              }}</Radio
            >
          </RadioGroup>
        </div>
      </compWrapper>
    </div>
    <div class="warehouse-content">
      <TableList
        v-bind="tableProps"
        @on-radio-change="handleWarehouseChange"
      ></TableList>
    </div>
    <div class="button-container pull-right padding-top-15">
      <Button class="margin-right-15" type="primary" @click="confirm"
        >确认</Button
      >
      <Button @click="$emit('on-close')">取消</Button>
    </div>
  </div>
</template>

<script>
import TableList from "@components/templates/tablelist";
import {
  HttpGetOrgAreaOption,
  HttpGetNoAreaWarehouse,
} from "@/service/inbound";
export default {
  components: {
    TableList,
  },
  data() {
    return {
      areaData: [],
      areaId: null,
      warehouseId: null,
      selectedWarehouseData: {},
      selectedAreaData: {},
      refreshTable: true,
    };
  },
  created() {
    this.getArea();
  },
  methods: {
    handleAreaChange(areaId) {
      this.areaData.map((row) => {
        row.items.map((item) => {
          if (item.id == areaId) {
            this.selectedAreaData = item;
          }
        });
      });
      this.selectedWarehouseData = {};
      this.refreshTable++;
    },
    handleWarehouseChange(row) {
      if (!row) return;
      console.log(row);
      this.areaId = null;
      this.warehouseId = row.id;
      this.selectedWarehouseData = row;
    },
    async getArea() {
      await HttpGetOrgAreaOption().then(
        (res) => {
          this.areaData = Object.keys(res.data).map((key) => {
            return {
              name: key,
              items: res.data[key],
            };
          });
        },
        (err) => {
          this.$VMessage.error(err.message);
        }
      );
      console.log(this.areaData);
    },
    confirm() {
      if (!this.areaId && !this.warehouseId)
        return this.$VMessage.error("必须选取一个区域或仓库");
      // 选中了仓库
      if (!this.areaId) {
        this.$emit("on-select-warehouse", this.selectedWarehouseData);
        this.$emit("on-close");
      }
      // 选中了区域
      else {
        this.$emit("on-select-area", this.selectedAreaData);
        this.$emit("on-close");
      }
    },
  },
  computed: {
    tableProps() {
      return {
        ajaxRequest: HttpGetNoAreaWarehouse,
        startUp: this.refreshTable,
        Searchs: {
          show: true,
          style: "border:none;",
          align: "left",
        },
        interceptRequest: (requestData) => {
          let params = {
            ...requestData,
          };
          if (params.search.warehouse) {
            params.warehouse = params.search.warehouse;
            delete params.search.warehouse;
          } else {
            delete params.search.warehouse;
            delete params.warehouse;
          }
          return params;
        },
        SearchsData: [
          {
            label: "仓库名称",
            tag: "vInput",
            key: "warehouse",
            style: "width: 200px;",
            show: true,
          },
        ],
        columns: [
          {
            type: "selection",
            isRadio: true,
            width: 50,
            align: "center",
          },
          {
            title: "仓库",
            render: (h, { row }) => {
              return (
                <div>
                  {row.code}({row.title})
                </div>
              );
            },
          },
        ],
      };
    },
  },
};
</script>

<style>
</style>
